export default __webpack_public_path__ + "static/media/sponsor-smidgens.4da0e747.png";